import { useState } from 'react'
import { Container } from '../../../../components'
import {
  Box,
  Divider,
  Stack,
  Typography,
  Link,
} from '@elphasecure/elpha-design-system'
import { SmallLogoColored, PolicyPriceSVG } from '../../../../assets/svgs'
import { useSearchParams } from 'react-router-dom'
import { useGetPolicyBillingInfo } from '../../policy_management/api/useGetPolicyBillingInfo'
import { Confirmation } from '../components/Confirmation'
import { Invoice } from '../components/Invoice'

export const Billing = () => {
  const [activeStep, setActiveStep] = useState(0)
  let [searchParams] = useSearchParams()
  let paymentUuid = searchParams.get('payment_link_uuid')

  const { data: billingInfo, isLoading: billingInfoIsLoading } =
    useGetPolicyBillingInfo(paymentUuid)

  const handleNext = async () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const steps = [
    {
      title: 'Your Cyber Policy Quote',
      label: `Here’s your quote for ${billingInfo?.data?.policy_details?.policyholder?.legal_entity_name}`,
      component: (
        <Invoice
          handleNext={handleNext}
          policyData={billingInfo?.data?.policy_details}
          paymentData={billingInfo?.data?.payment}
          isLoading={billingInfoIsLoading}
          clientSecret={billingInfo?.data?.client_secret}
        />
      ),
    },
    {
      title: 'Your Coverage is Ready',
      label:
        'Payment is complete and your policy is activated. To ensure your coverage continues, please complete the following steps in 5 days.',
      component: (
        <Confirmation
          policyData={billingInfo?.data?.policy_details}
          isLoading={billingInfoIsLoading}
          paymentData={billingInfo?.data?.payment}
        />
      ),
    },
  ]

  const totalSteps = () => {
    return steps.length
  }

  const isLastStep = () => {
    return activeStep === totalSteps() - 1
  }

  return (
    <Stack divider={<Divider orientation="horizontal" flexItem />}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingY: '2.8rem',
        }}
      >
        <SmallLogoColored />
      </Box>
      {!billingInfoIsLoading && (
        <>
          <Container maxWidth="lg" sx={{ paddingY: '8.0rem', flex: 1 }}>
            <Box sx={{ marginBottom: '5.6rem' }}>
              <Stack
                spacing="2.8rem"
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <PolicyPriceSVG />
                <Box>
                  <Typography
                    variant="headlineXLarge"
                    component="h1"
                    sx={{ fontWeight: '700', color: 'primary.500' }}
                  >
                    {billingInfo?.data?.payment_status
                      ? 'Your Cyber Policy has Been Paid'
                      : steps[activeStep].title}
                  </Typography>
                  <Typography
                    variant="bodyLarge"
                    sx={{
                      color: 'primary.400',
                      maxWidth: '70rem',
                      textAlign: 'center',
                    }}
                  >
                    {billingInfo?.data?.payment_status ? (
                      <>
                        Questions? Contact us at{' '}
                        <Link href="mailto:help@elphasecure.com">
                          help@elphasecure.com
                        </Link>{' '}
                        or chat with our team right now.
                      </>
                    ) : (
                      steps[activeStep].label
                    )}
                  </Typography>
                </Box>
              </Stack>
            </Box>
            {billingInfo?.data?.payment_status
              ? null
              : steps[activeStep].component}
          </Container>
          {!isLastStep() && !billingInfo?.data?.payment_status && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                paddingY: '2.8rem',
              }}
            >
              <Typography variant="bodySmall">
                Need more details?{' '}
                <Link
                  variant="bodySmall"
                  download
                  href="/pdfs/sample-policy.pdf"
                  target="_blank"
                >
                  Download a sample policy{' '}
                </Link>
                <Typography variant="bodySmall" sx={{ color: 'primary.400' }}>
                  to read more on each cyber coverage or{' '}
                </Typography>
                <Link
                  variant="bodySmall"
                  download
                  href={
                    billingInfo?.data?.policy_details?.urls?.application?.url
                  }
                >
                  review your policy application.
                </Link>
              </Typography>
            </Box>
          )}
        </>
      )}
    </Stack>
  )
}

export default Billing
